import {
  GET_CHANGE_REQUEST_BULK_ACTIONS,
  GET_CHANGE_REQUEST_BULK_ACTIONS_ERROR,
  GET_CHANGE_REQUEST_DETAIL,
  GET_CHANGE_REQUEST_DETAIL_ERROR,
  GET_CHANGE_REQUEST_LIST,
  GET_CHANGE_REQUEST_LIST_ERROR,
  GET_CHANGE_REQUEST_STATUS_LIST,
  GET_CHANGE_REQUEST_STATUS_LIST_ERROR,
} from "../../actions/types";

const initialState = {
  changeRequestList: [],
  changeRequestBulkActions: [],
  changeRequestStatusList: [],
  changeRequestDetail: null,
};

export const changeRequest = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHANGE_REQUEST_LIST:
      return {
        ...state,
        changeRequestList: action.payload.data || [],
      };
    case GET_CHANGE_REQUEST_LIST_ERROR:
      return {
        ...state,
        changeRequestList: [],
      };
    case GET_CHANGE_REQUEST_BULK_ACTIONS:
      return {
        ...state,
        changeRequestBulkActions: action.payload.data || [],
      };
    case GET_CHANGE_REQUEST_BULK_ACTIONS_ERROR:
      return {
        ...state,
        changeRequestBulkActions: [],
      };
    case GET_CHANGE_REQUEST_STATUS_LIST:
      return {
        ...state,
        changeRequestStatusList: action.payload.data || [],
      };
    case GET_CHANGE_REQUEST_STATUS_LIST_ERROR:
      return {
        ...state,
        changeRequestStatusList: [],
      };
    case GET_CHANGE_REQUEST_DETAIL:
      return {
        ...state,
        changeRequestDetail: action.payload.data || null,
      };
    case GET_CHANGE_REQUEST_DETAIL_ERROR:
      return {
        ...state,
        changeRequestDetail: null,
      };
    default:
      return state;
  }
};
